import buildRoute from './buildRoute'

export const getEngineByIdentifier = async (engineIdentifier: string) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'powerlink-get-engine-by-identifier',
            data: { engineIdentifier },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error('Error fetching engine by identifier:', err)
        return err
    }
}

const powerlinkRoutes = {
    getEngineByIdentifier,
}

export default powerlinkRoutes
